import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import App from './App';
import './index.css';

// 加载Socket.IO库
declare global {
  interface Window {
    io: any;
  }
}

// 动态加载Socket.IO库
const loadSocketIO = () => {
  return new Promise((resolve, reject) => {
    if (window.io) {
      resolve(window.io);
      return;
    }
    
    const script = document.createElement('script');
    script.src = '/socket.io/socket.io.js';
    script.onload = () => {
      if (window.io) {
        resolve(window.io);
      } else {
        reject(new Error('Socket.IO库加载失败'));
      }
    };
    script.onerror = () => {
      reject(new Error('Socket.IO库加载失败'));
    };
    document.head.appendChild(script);
  });
};

// 初始化Socket.IO
loadSocketIO().then(() => {
  console.log('✅ Socket.IO库加载成功');
}).catch((error) => {
  console.error('❌ Socket.IO库加载失败:', error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 主题包装组件
const ThemedApp: React.FC = () => {
  const { antdTheme } = useTheme();
  
  return (
    <ConfigProvider
      locale={zhCN}
      theme={antdTheme}
    >
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <App />
      </BrowserRouter>
    </ConfigProvider>
  );
};

root.render(
  <ThemeProvider>
    <ThemedApp />
  </ThemeProvider>
);



